<template>
  <div>
    <v-layout row v-if="error">
      <v-flex xs12 sm8 offset-sm2>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <h3 class="headline mb-3">Check your email</h3>
        <p>We've sent you an email. Click the link in the email to reset your password.</p>
        <p>If you don't see the email, check other places it might be, like your junk, spam, social, or other folders.</p>
        <p><router-link to="forgot-password">I didn't receive the email</router-link></p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { HTTP } from "@/http-common";
export default {
  props: {
    expired: {
      required: false
    }
  },
  data() {
    return {
      valid: true,
      loading: false,
      expiredLink: false,
      email: "",
      password: "",
      rules: {
        required: v => {
          return !!v || "Required";
        },
        email: v => {
          if (this.brand.rules.email) {
            return this.brand.rules.email(v);
          } else {
            return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid";
          }
        }
      }
    };
  },
  mounted() {
    if (this.$route.query.expired && this.$route.query.expired === "1") {
      this.expiredLink = true;
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push("/");
      }
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        HTTP.post("/forgot-password", {
          email: this.email
        })
          .then(response => {
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            console.error(e);
          });
      } else {
        console.log("invalid...");
      }
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    }
  }
};
</script>

<style scoped>
.expired-link {
  color: #e53935;
  font-weight: light;
}
</style>


// WEBPACK FOOTER //
// src/components/user/ResetEmailSent.vue